module.exports = __webpack_public_path__ + "files/30e9b1f1378b074b6d6284b4b8066ea8.png";